import "./index.css";
// The installable app: service worker, updates, install prompt, theme color (components/assets/js/pwa.js).
import "../../components/assets/js/pwa.js";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
